<template>
  <div id="calendar-month">
    <sticky class="page-header sticky-page-header page-header--new"
            :back-button="false"
            :calendarMonth="gApiReady && !googleLogged"
            :classOnRightSlot="'columns is-gapless is-narrow'">
      <div slot="left" class="columns is-vcentered is-gapless">
        <div class="column is-3 minW300p maxW300p has-bg-black is-self-stretched has-text-white columns is-gapless is-vcentered">
          <div class="column is-padding-left">
            <span>{{rdvs.length + reminders.length + options.length + validity.length}} actions programmées</span>
          </div>
        </div>
        <router-link :to="{name: 'CalendarList'}"
                     class="column is-narrow is-border-right">
          <a class="page-header-btn is-small has-text-black-ter">
            <span class="icon"><i class="far fa-clock is-size-4"></i></span><span
                  class=" is-padding-left-xxsmall has-text-weight-medium">ACTIONS À VENIR</span>
          </a>
        </router-link>
        <div @click="goToMonthLeft()" class="control is-margin-left">
          <button class="button is-square is-border button is-small is-transform-none is-grey is-border is-inverted">
            <i class="fal fa-chevron-left"></i>
          </button>
        </div>
        <div @click="goToMonthRight()" class="control is-margin-left-xsmall">
          <button class="button is-square is-border button is-small is-transform-none is-grey is-border is-inverted">
            <i class="fal fa-chevron-right"></i>
          </button>
        </div>
        <div class="column is-narrow is-self-stretched is-flex">
          <div class="is-self-centered has-text-centered is-padding-left">
            <div class="title is-size-5 is-size-4-widescreen"><b class="is-uppercase">{{currentMonth|monthFormat}}</b>
            </div>
          </div>
        </div>
      </div>
      <div class="column is-self-centered is-padding-right-small" slot="left-action">
        <button @click="goToDay()" class="button is-small is-transform-none is-grey is-border is-inverted">
          <span class="has-text-grey has-text-weight-medium">Aujourd'hui</span>
        </button>
        <!-- aucune action pour lui, il doit être actif-->
        <button v-if="currentMonthDate !== todayMonthDate" @click="goToMonthRouter"
                class="button is-small is-transform-none is-grey is-border is-inverted">
          <span class="has-text-grey has-text-weight-medium">Mois</span>
        </button>
        <button v-else class="button is-small is-transform-none is-static is-border">
          <span class="has-text-grey has-text-weight-medium">Mois</span>
        </button>
      </div>
      <a v-if="gApiReady && !googleLogged" @click="googleLogin()" class="dropdown-item" slot="dropdown-content">
        <span class="icon"><i class="fab fa-google"></i></span><span>Connexion google agenda</span>
      </a>
      <a @click="open" class="dropdown-item" slot="dropdown-content">
        <span class="icon"><i class="fas fa-calendar-plus"></i></span>
        <span>Nouvelle action</span>
      </a>
      <google-sync-button slot="left-action"></google-sync-button>
    </sticky>
    <event-notification style="position: relative;"></event-notification>
    <div class="page-content columns is-gapless collapseColumn collapseColumn--left collapseColumn--left--small collapseColumn--alignStart"
         id="columns-collapse">
      <div class="column is-3 has-bg-white is-border-right">
        <div class="has-flatpickr-responsive has-flatpickr-theme--s1 has-flatpickr-padding-h has-bg-white-ter is-border-bottom is-padding-bottom-small"
        >
          <flat-pickr :config="configDateMini"
                      id="flatpickr"
                      class="input is-hidden is-radiusless is-shadowless flatpickr-input is-noDecalPosTop"
                      name="date"
                      v-model="formatedCurrentMonth"
                      @on-change="goToDay"
          ></flat-pickr>
        </div>
        <div>
          <div v-if="hasFilter"
               class="is-padding-left-small is-padding-top-xsmall is-padding-bottom-xsmall is-border-top has-bg-annonce">
            <a class="has-text-white is-size-6" @click.prevent.stop="resetFilters">
              <span class="icon"><i class="fas fa-undo"></i></span>
              <span class="is-italic">Réinitialiser tous les filtres</span>
            </a>
          </div>
          <div class="column is-gapless is-12 columns is-multiline is-vcentered is-paddingless-bottom is-padding-top-small is-padding-left-small is-padding-right-small">
            <label for="" class="label is-transform-none has-text-grey is-padding-bottom-xsmall">Filtrage par critères
              : </label>
            <div class="column is-12 columns is-variable is-1 is-multiline">
              <div v-for="type in rdvTypeList" :key='type.value'
                   class="column is-3 is-paddingless-top is-paddingless-bottom is-paddingless-left">
                <input :id="type.value" v-model="filters.rdv_type" :value="type.label" name="typeRdv"
                       :class="{'is-active' : filters.rdv_type.map(x=> x.value).includes(type.value)}"
                       checked="checked" class="checkradiocase is-primary is-fullwidth" type="checkbox"
                       @change="updateRdvType(filters.rdv_type, `#${type.value}`)">
                <label :for="type.value">{{type.label}}</label>
              </div>
            </div>
          </div>
          <div class="is-padding-left-small is-padding-right-small is-padding-top-small">
            <div class="control">
              <div @click="openSellerSelectionQuickView('author')" class="input">
                <div v-if="filters.author && filters.author.length">
                  <span class="">Organisateurs ({{filters.author.length}})</span>
                </div>
                <span v-else class="has-text-grey">Sélectionner organisateur</span>
              </div>
            </div>
          </div>
          <div class="is-padding-left-small is-padding-right-small is-padding-top-small">
            <div class="control">
              <div @click="openContactSelectionQuickView()" class="input">
                <div v-if="filters.contact && filters.contact.length">
                  <span class="">contacts ({{filters.contact.length}})</span>
                </div>
                <span v-else class="has-text-grey">Rechercher contact</span>
              </div>
            </div>
          </div>
          <div class="is-padding-left-small is-padding-right-small is-padding-top-small">
            <div class="control">
              <div @click="openSellerSelectionQuickView('participant')" class="input">
                <div v-if="filters.seller && filters.seller.length">
                  <span class="">Participants ({{filters.seller.length}})</span>
                </div>
                <span v-else class="has-text-grey">Rechercher participant</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="column has-bg-light is-self-stretched is-paddingless">
        <div class="column is-12 is-paddingless" v-if="exportedEvents && exportedEvents.length">
          <div class="columns is-vcentered is-border-left is-padding-top-xsmall is-padding-bottom-xsmall is-padding-left is-padding-right has-bg-danger has-text-white">
            <span class="column is-narrow is-paddingless is-padding-left-xsmall is-size-6"><b>{{exportedEvents.length}} évènement<span
                    v-if="exportedEvents.length > 1">s</span> Google détecté<span
                    v-if="exportedEvents.length > 1">s</span> sur votre agenda.</b></span>
            <em class="column is-paddingless is-size-6 is-padding-left-xsmall" v-if="googleLogged">
              <button class="button is-border is-radius is-small is-transform-none"
                      @click="syncroAuto()"
              >
                <span v-if="!loaderSyncro" class="has-text-weight-medium">Synchroniser tous les évènements</span>
                <span v-else><i class="fas fa-spinner fa-spin is-margin-xsmall"></i></span>
              </button>
            </em>
            <em class="column is-paddingless is-size-6 has-text-right" v-else>(Connectez-vous à votre compte Google pour
              permettre la synchronisation automatique des rendez-vous)</em>
          </div>
        </div>
        <div class="is-padding is-border-bottom" v-if="hasFilter">
          <label for="" class="is-size-6 label is-padding-bottom-small">Vos critères de recherche :</label>
          <div class="tags">
            <span class="tag is-primary is-rounded" v-if="filters.author && filters.author.length" v-for="(auth, i) in author">
              {{auth.last_name}} {{auth.first_name}} <a @click="deleteAuth(i)"
                                                            class="icon is-white is-margin-left-xsmall"><i
                    class="fas fa-times-circle has-text-white"></i></a>
            </span>
            <span class="tag is-primary is-rounded" v-if="filters.contact && filters.contact.length" v-for="(cont, i) in contact">
              {{cont.last_name}} {{cont.first_name}} <a @click="deleteContact(i)"
                                                              class="icon is-white is-margin-left-xsmall"><i
                    class="fas fa-times-circle has-text-white"></i></a>
            </span>
            <span class="tag is-primary is-rounded" v-if="filters.seller && filters.seller.length" v-for="(sel, i) in seller">
              {{sel.last_name}} {{sel.first_name}}<a @click="deleteSeller(i)"
                                                           class="icon is-white is-margin-left-xsmall"><i
                    class="fas fa-times-circle has-text-white"></i></a>
            </span>
            <span class="tag is-primary is-rounded" v-if="filters.rdv_type && filters.rdv_type.length"
                  v-for="(type, i) in filters.rdv_type" :key="'type-' + i">
              {{type}} <a @click="deleteTypeFilter(i)" class="icon is-white is-margin-left-xsmall"><i
                    class="fas fa-times-circle has-text-white"></i></a>
            </span>
            <span class="tag is-annonce is-rounded has-cursor-pointer" @click="resetFilters">
              Réinitialiser les filtres <span class="icon is-white is-margin-left-xsmall"><i
                    class="fas fa-undo"></i></span>
            </span>
          </div>
        </div>
        <div class="bulma-calendar is-height-full">
          <div class="calendar is-large is-borderless is-border-bottom">
            <div class="calendar-container">
              <div class="calendar-header">
                <div class="calendar-date">Lundi</div>
                <div class="calendar-date">Mardi</div>
                <div class="calendar-date">Mercredi</div>
                <div class="calendar-date">Jeudi</div>
                <div class="calendar-date">Vendredi</div>
                <div class="calendar-date">Samedi</div>
                <div class="calendar-date">Dimanche</div>
              </div>
              <div class="calendar-body">
                <calendar-day-item v-for="day in days" :key="day.key" :date="day.date"
                                   :id="day.date.format('MMMMYYYYDD')" :my-rdv='myRdv' :filters="filters"
                                   @rdvLength='getTotal'
                                   :class="{'is-disabled' : currentMonth.format('MM') !== day.date.format('MM')}">
                </calendar-day-item>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import CalendarDayItem from './CalendarDayItem'
  import GoogleSyncButton from './GoogleSyncButton'
  import { CalendarMx, GoogleMx } from '../../mixins'
  import { mapGetters, mapState } from 'vuex'
  import { cleanQuery } from '../../utils'
  import moment from 'moment'
  import Datepicker from 'vuejs-datepicker'
  import { isNil, compact, flatten, debounce, isEmpty, cloneDeep } from 'lodash'

  export default {
    name: 'CalendarMonthView',
    mixins: [CalendarMx, GoogleMx],
    components: {
      CalendarDayItem,
      GoogleSyncButton,
      Datepicker
    },
    props: {},
    data () {
      return {
        loaderSyncro: null,
        rdvTotal: 0,
        filters: {
          author: [],
          seller: [],
          rdv_type: [],
          successful: null,
          canceled: null,
          deferred: null,
          contact: []
        },
        initFilters: {
          author: [],
          seller: [],
          rdv_type: [],
          successful: null,
          canceled: null,
          deferred: null,
          contact: []
        },
        rdvTypeList: {
          R0: { value: 'R0', label: 'R0' },
          R1: { value: 'R1', label: 'R1' },
          R2: { value: 'R2', label: 'R2' },
          R3: { value: 'R3', label: 'R3' }
        },
        authors: [],
        author: [],
        seller: [],
        contact: [],
        myRdv: false,
        isLoadingCalendarEvents: false,
        isLoadingUsers: false,
        isLoadingAccesses: false,
        isLoadingRdvs: false,
        isLoadingOptions: false,
        isLoadingReminders: false,
        fromUser: false,
        accesses: [],
        currentDayDate: new Date(),
        formatedCurrentMonth: null,
        configDate: {
          altFormat: 'F Y',
          altInput: true,
          dateFormat: 'l d F Y',
          disableMobile: true
        },
        configDateMini: {
          inline: true,
          enableTime: false,
          noCalendar: false,
          defaultDate: '2019-04-19 08:30',
          altFormat: 'F j, Y H:i',
          dateFormat: 'Y-m-d H:i',
          time_24hr: true
        }
      }
    },
    filters: {
      monthFormat (v) {
        return moment(v).format('MMMM YYYY')
      }
    },
    computed: {
      ...mapState(['calendarEvents', 'googleLogged', 'quickview']),
      ...mapGetters(['isAdmin', 'isSectorManager', 'isManager', 'isSeller', 'isOperator', 'googleEmail']),
      loadingProgress () {
        let progress = 0
        let loaders = ['isLoadingOptions', 'isLoadingReminders', 'isLoadingRdvs', 'isLoadingCalendarEvents']
        if (this.isAdmin || this.isSectorManager) {
          loaders.push('isLoadingUsers')
        }
        let stepProgress = 100 / loaders.length
        loaders.forEach(x => {
          if (this[x] === false) {
            progress += stepProgress
          }
        })
        return progress
      },
      hasFilter () {
        if (cleanQuery(this.filters) === cleanQuery(this.initFilters)) return false
        for (const key in this.filters) {
          if ((Array.isArray(this.filters[key]) || typeof this.filters[key] === 'object') && !isEmpty(this.filters[key])) {
            return true
          } else if (typeof this.filters[key] !== 'object' && this.filters[key] !== undefined && this.filters[key] !== null && this.filters[key] !== 0 &&
            this.filters[key] !== '') {
            return true
          }
        }
        return false
      },
      isLoading () {
        return this.isLoadingRdvs && this.isLoadingOptions
      },
      exportedEvents () {
        return compact(flatten(Object.values(this.calendarEvents).map(e => {
          if (e && 'rdvs' in e) {
            return Object.values(e.rdvs).filter(x => isNil(x.google_event_id) === false && isNil(x.google_calendar_id) === false)
          }
        })))
      },
      rdvs () {
        let month = moment(this.formatedCurrentMonth).format('MM/YYYY')
        let days = Object.keys(this.calendarEvents).filter(x => {
          return x.includes(month)
        })
        let rdvs = []
        for (let day of days) {
          if ('rdvs' in this.calendarEvents[day] && !isEmpty(this.calendarEvents[day].rdvs)) {
            Object.values(this.calendarEvents[day].rdvs).map(x => {
              rdvs.push(x)
            })
          }
        }
        rdvs = rdvs.filter(x => x.canceled === false)
        rdvs = rdvs.filter(x => x.deferred === false)

        if (this.myRdv) {
          rdvs = rdvs.filter(x => x.seller === this.currentUserPk || x.guests.includes(this.currentUserPk))
        }
        if ('author' in this.filters && this.filters.author && this.filters.author.length) {
          let allAuthor = []
          let selectedAuthor = []
          this.filters.author.forEach(author => {
            selectedAuthor[author] = []
            selectedAuthor[author] = rdvs.filter(x => x.author === author.pk)
            allAuthor = allAuthor.concat(selectedAuthor[author])
          })
          rdvs = allAuthor
        }
        if (this.filters.contact && this.filters.contact.length) {
          let allContact = []
          let selectedContact = []
          this.filters.contact.forEach(contact => {
            selectedContact[contact] = []
            selectedContact[contact] = rdvs.filter(x => x.contact === contact.pk)
            allContact = allContact.concat(selectedContact[contact])
          })
          rdvs = allContact
        }
        if ('seller' in this.filters && this.filters.seller && this.filters.seller.length) {
          let allSeller = []
          let selectedSeller = []
          this.filters.seller.forEach(seller => {
            selectedSeller[seller] = []
            selectedSeller[seller] = rdvs.filter(x => x.seller === seller.pk)
            allSeller = allSeller.concat(selectedSeller[seller])
          })
          rdvs = allSeller
        }
        if (this.filters.rdv_type && this.filters.rdv_type.length) {
          let rdvsType = []
          let allRdvType = []
          for (let type of this.filters.rdv_type) {
            rdvsType[type] = []
            rdvsType[type] = rdvs.filter(x => { return x.rdv_type === type })
            allRdvType = allRdvType.concat(rdvsType[type])
          }
          rdvs = allRdvType
        }
        return rdvs
      },
      reminders () {
        let month = moment(this.formatedCurrentMonth).format('MM/YYYY')
        let days = Object.keys(this.calendarEvents).filter(x => {
          return x.includes(month)
        })
        let reminders = []
        for (let day of days) {
          if ('reminders' in this.calendarEvents[day] && !isEmpty(this.calendarEvents[day].reminders)) {
            Object.values(this.calendarEvents[day].reminders).map(x => {
              reminders.push(x)
            })
          }
        }
        return reminders
      },
      options () {
        let month = moment(this.formatedCurrentMonth).format('MM/YYYY')
        let days = Object.keys(this.calendarEvents).filter(x => {
          return x.includes(month)
        })
        let options = []
        for (let day of days) {
          if ('options' in this.calendarEvents[day] && !isEmpty(this.calendarEvents[day].options)) {
            Object.values(this.calendarEvents[day].options).map(x => {
              options.push(x)
            })
          }
        }
        return options
      },
      validity () {
        let month = moment(this.formatedCurrentMonth).format('MM/YYYY')
        let days = Object.keys(this.calendarEvents).filter(x => {
          return x.includes(month)
        })
        let validity = []
        for (let day of days) {
          if ('users' in this.calendarEvents[day] && !isEmpty(this.calendarEvents[day].users)) {
            Object.values(this.calendarEvents[day].users).map(x => {
              validity.push(x)
            })
          }
        }
        return validity
      },
      currentMonthDate () {
        return moment(this.formatedCurrentMonth).format('DD/MM/YYYY')
      },
      todayMonthDate () {
        return moment().format('DD/MM/YYYY')
      }
    },
    watch: {
      quickview ({ mode, params, results }) {
        if (results) {
          if (mode === 'SELLER_SELECTION') {
            if (params.type === 'author') {
              results.entities.forEach(x => {
                this.author.push(x)
                this.filters.author.push(x)
              })
              this.$nextTick(() => {
                this.initMonthCalendar()
              })
            } else if (params.type === 'participant') {
              results.entities.forEach(x => {
                this.seller.push(x)
                this.filters.seller.push(x)
              })
              this.$nextTick(() => {
                this.initMonthCalendar()
              })
            }
          } else if (mode === 'CONTACT_SELECTION') {
            results.entities.forEach(x => {
              this.contact.push(x)
              this.filters.contact.push(x)
            })
            this.$nextTick(() => {
              this.initMonthCalendar()
            })
          } else if (mode === 'NEW_CALENDAR_ACTION') {
            console.log(results.val)
            let day
            let month
            let year
            if ('reminder' in results.val && results.val.reminder) {
              let date = moment(results.val.reminder.date)
              day = date.get('date')
              month = date.get('month')
              month = month + 1
              year = date.get('year')
              this.$router.push({ name: 'CalendarDayView', query: { day, month, year, panel: 'REMINDERS' } })
            } else if ('rdv' in results.val && results.val.rdv) {
              let date = moment(results.val.rdv.date)
              day = date.get('date')
              month = date.get('month')
              month = month + 1
              year = date.get('year')
              this.$router.push({ name: 'CalendarDayView', query: { day, month, year } })
            }
          }
        }
      },
      currentMonth (v) {
        this.formatedCurrentMonth = v.isValid() ? v.toDate() : moment.toDate()
        this.initMonthCalendar()
        this.loadEvents()
      }
    },
    methods: {
      open () {
        this.$store.commit('setQuickview', {mode: 'NEW_CALENDAR_ACTION'})
      },
      deleteAuth (i) {
        if (Array.isArray(this.filters.author)) {
          this.filters.author.splice(i, 1)
          this.author.splice(i, 1)
        } else {
          this.$set(this.filters, 'author', [])
          this.$set(this, 'author', [])
        }
        this.$nextTick(() => {
          this.initMonthCalendar()
        })
      },
      deleteSeller (i) {
        if (Array.isArray(this.filters.seller)) {
          this.filters.seller.splice(i, 1)
          this.seller.splice(i, 1)
        } else {
          this.$set(this.filters, 'seller', [])
          this.$set(this, 'seller', [])
        }
        this.$nextTick(() => {
          this.initMonthCalendar()
        })
      },
      deleteContact (i) {
        if (Array.isArray(this.filters.contact)) {
          this.filters.contact.splice(i, 1)
          this.contact.splice(i, 1)
        } else {
          this.$set(this.filters, 'contact', [])
          this.$set(this, 'contact', [])
        }
        this.$nextTick(() => {
          this.initMonthCalendar()
        })
      },
      goToMonthRouter () {
        this.fromUser = false
        this.currentMonth = this.today.clone()
        this.$nextTick(() => {
          this.fromUser = true
        })
      },
      openContactSelectionQuickView () {
        let params = {
          mode: 'append'
        }
        this.$store.commit('setQuickview', { mode: 'CONTACT_SELECTION', params: params })
      },
      openSellerSelectionQuickView (value) {
        let params = {}
        params.facets = {
          'USER': ['is_external:False']
        }
        params.mode = 'append'
        params.type = value
        this.$store.commit('setQuickview', { mode: 'SELLER_SELECTION', params: params })
      },
      updateKeyFilter (e, key) {
        this.$set(this.filters, key, e)
        this[key] = null
        this.$nextTick(() => {
          this.initMonthCalendar()
        })
      },
      deleteTypeFilter: debounce(function (i) {
        if (Array.isArray(this.filters.rdv_type)) this.filters.rdv_type.splice(i, 1)
        else this.$set(this.filters, 'rdv_type', [])
      }, 200),
      // xlsExportUrl () {
      //   const query = { pk: [this.adv.pk] }
      //   return exportXls('advs-export', query, true, `ADV-${this.adv.ref}`)
      // },
      googleLogin () {
        window.gapi.auth2.getAuthInstance().signIn().then(res => {
        })
      },
      syncroAuto () {
        this.loaderSyncro = true
        for (let exportedEvent of this.exportedEvents) {
          this.googleSync(exportedEvent)
        }
        setTimeout(() => {
          this.$notify({
            type: 'is-success',
            text: 'Synchronisation réussie'
          })
          this.loaderSyncro = false
        }, 2000)
      },
      getTotal (e) {
        this.rdvTotal = this.rdvTotal + e
      },
      resetFilters () {
        this.contact = []
        this.author = []
        this.seller = []
        this.filters = cloneDeep(this.initFilters)
      },
      inputChange: debounce(function () {
        this.$nextTick(() => {
          this.initMonthCalendar()
        })
      }, 300),
      updateAuthorFilter (e) {
        this.$set(this.filters, 'author', e.pk)
        this.$set(this, 'author', e)
        this.$nextTick(() => {
          this.initMonthCalendar()
        })
      },
      updateSellerFilter (e) {
        this.$set(this.filters, 'seller', e.pk)
        this.$set(this, 'seller', e)
        this.$nextTick(() => {
          this.initMonthCalendar()
        })
      },
      updateContactFilter (e) {
        this.$set(this.filters, 'contact', e.pk)
        this.$set(this, 'contact', e)
        this.$nextTick(() => {
          this.initMonthCalendar()
        })
      },
      updateRdvType (e, el) {
        this.$set(this.filters, 'rdv_type', e)
        this.$nextTick(() => {
          this.fixFocus(el)
          this.initMonthCalendar()
        })
      },
      fixFocus (element) {
        // Debug focus persistant sur les cases à cocher (app/Maison) avec chrome
        document.querySelector(element).blur()
      },
      getAuthors (query) {
        let profilsPk = []
        if (this.profilOrderList && this.profilOrderList.length) {
          profilsPk = this.profilOrderList.filter(x => !x.is_external).map(x => x.pk)
        }
        let params = {
          profil: profilsPk
        }
        if (query) params.query = query
        this.$api.userService.get(params).then(r => {
          this.authors = r.data.items
        })
      },
      updateMyRDV () {
        this.myRdv = !this.myRdv
        this.initMonthCalendar()
      },
      newReminder () {
        this.$store.commit('setQuickview', { mode: 'NEW_REMINDER' })
      },
      newRdv () {
        this.$router.push({ name: 'CalendarCreate' })
      },
      closePicker () {
        setTimeout(() => {
          this.fromUser = false
        }, 200)
      },
      goToDay (e) {
        if (!this.fromUser) return
        let day
        let month
        let year
        if (e) {
          day = new Date(e[0]).getDate()
          month = new Date(e[0]).getMonth() + 1
          year = new Date(e[0]).getFullYear()
          this.currentDay = moment(`${day}/${month}/${year}`, 'DD/MM/YYYY')
          this.currentDayDate = new Date(this.currentDay)
        } else if (this.formatedCurrentMonth) {
          let date = moment(this.formatedCurrentMonth)
          day = date.get('date')
          month = date.get('month')
          month = month + 1
          year = date.get('year')
        }
        this.$router.push({ name: 'CalendarDayView', query: { day, month, year } })
      }
    },
    mounted () {
      this.$nextTick(() => {
        let top = document.querySelector('#calendar-month')
        this.$scrollTo(top, 400)
      })
    },
    created () {
      if ('date' in this.$route.query && this.$route.query.date) {
        this.currentMonth = moment(this.$route.query.date)
      }
      this.getAuthors()
      setTimeout(() => {
        this.fromUser = true
      }, 500)
    }
  }
</script>

<style>
  .LoadingBar--to_right {
    left: 0;
  }

  .LoadingBar {
    transition: all .6s ease;
    -moz-transition: all .6s ease;
    -webkit-transition: all .6s ease;
    -o-transition: all .6s ease;
    background: #5cb4eb;
    height: 3px;
    opacity: 1;
  }

  .LoadingBar.hidden {
    opacity: 0;
  }
</style>

<style scoped>
  .select {
    height: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/components/calendar/CalendarMonthView.vue